import { useEffect, useMemo, useRef, useState } from "react";
import NumberPagination from "../components/NumberPagination";
import PagedTable from "../components/PagedTable";
import SearchBar from "../components/SearchBar";

export default function ProjectsPage() {
    const [projects, setProjects] = useState([]); // Store projects fetched from MySQL
    const [filteredProjects, setFilteredProjects] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentFirstPage, setCurrentFirstPage] = useState(1);
    const headerRef = useRef(null);

    const numPageButtons = 10;
    const numItemsPerPage = 15;

    const projectsOnCurrentPage = useMemo(() => {
        if (!filteredProjects || filteredProjects.length === 0) return [];
        const start = (currentPage - 1) * numItemsPerPage;
        const end = currentPage * numItemsPerPage;
        return filteredProjects.slice(start, end);
    }, [filteredProjects, currentPage]);

    useEffect(() => {
        async function fetchData() {
            const data = [];
            setProjects(data || []);
        }
        fetchData(); // Call the async function
    }, []);
    
    const pagination = (
        <NumberPagination
            length={filteredProjects.length}
            numPageButtons={numPageButtons}
            numItemsPerPage={numItemsPerPage}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            currentFirstPage={currentFirstPage}
            setCurrentFirstPage={setCurrentFirstPage}
            headerRef={headerRef}
        />
    );

    // The reason for using useMemo here is to prevent unnecessary re-renders
    // You can find more details in the News.js component
    const filterKeys = useMemo(() => ['title'], []);
    const searchBar = (
        <SearchBar
            data={projects}
            setFilteredData={setFilteredProjects}
            setCurrentPage={setCurrentPage}
            setCurrentFirstPage={setCurrentFirstPage}
            filterKeys={filterKeys}
        />
    );

    const table = (
        <div className="table-wrapper">
            <table>
                <thead>
                    <tr>
                        <th className='hori-vert-center' width='10%'>1</th>
                        <th className='hori-vert-center'>2</th>
                        <th className='hori-vert-center'>3</th>
                    </tr>
                </thead>
                <tbody>
                    {projectsOnCurrentPage.map((item, i) => (
                        <tr key={i}>
                            <td className='hori-vert-center'>x</td>
                            <td style={{textAlign: 'left'}}>{item.title}</td>
                            <td className='hori-vert-center'>y</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
    
    // TODO: Delete the oldWebsiteLink prop after the new website is fully functional.
    return (
        <PagedTable
            header="Projects"
            headerRef={headerRef}
            numberPagination={filteredProjects.length > numItemsPerPage ? pagination : null}
            table={table}
            searchBar={searchBar}
            oldWebsiteLink={"https://cc.ee.ntu.edu.tw/%7Eywchang/projects.html"}
        />
    );
}
